import { apiredeciclo } from '@/plugins/axios';

export default {
  getBrandCategories: filters =>
    apiredeciclo.get(
      `api/public_brands/tags?top=${filters.top}&skip=${filters.skip}`,
    ),
  getBrandList: filters =>
    apiredeciclo.get(
      `api/public_brands/list?top=${filters.top}&skip=${filters.skip}&shallow=${filters.shallow}&order_by=${filters.orderby}&q=${filters.qry}&tag=${filters.tag}`,
    ),
};
